export const currentTransactionContext = (transactionType) => ({
  type: "TRANSANCTION_TYPE",
  transactionType,
})
